import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SIDEBAR_OPEN_LOCALSTORAGE_NAME } from 'layout/Aside/constants';
import { Profile } from 'services/ProfileService/types';
import { ProfilePermissions, ProfileState } from './types';
import { FtsOrganizationProfileDto } from 'services/FtsOrganizationService/types';

const initialState: ProfileState = {
  profile: JSON.parse(sessionStorage.getItem('profile') || 'null'),
  permissions: JSON.parse(sessionStorage.getItem('permissions') || '[]'),
  tabSettings: JSON.parse(sessionStorage.getItem('tabSettings') || '[]'),
  isSidebarOpen: JSON.parse(localStorage.getItem(SIDEBAR_OPEN_LOCALSTORAGE_NAME) || 'false'),
  ftsProfile: JSON.parse(sessionStorage.getItem('ftsProfile') || 'null'),
  hasPrimaryCity: JSON.parse(sessionStorage.getItem('hasPrimaryCity') || 'null'),
  isUserAgentFromInvitation: JSON.parse(
    sessionStorage.getItem('isUserAgentFromInvitation') || 'null'
  ),
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<Profile>) => {
      sessionStorage.setItem('profile', JSON.stringify(action.payload));
      state.profile = action.payload;
    },
    setPermissions: (state, action: PayloadAction<ProfilePermissions[]>) => {
      sessionStorage.setItem('permissions', JSON.stringify(action.payload));
      state.permissions = action.payload;
    },
    setHasPrimaryCity: (state, action: PayloadAction<boolean>) => {
      sessionStorage.setItem('hasPrimaryCity', JSON.stringify(action.payload));
      state.hasPrimaryCity = action.payload;
    },
    toggleSidebar: (state, action: PayloadAction<boolean>) => {
      sessionStorage.setItem(SIDEBAR_OPEN_LOCALSTORAGE_NAME, JSON.stringify(action.payload));
      state.isSidebarOpen = action.payload;
    },
    setFtsStatusForAgent: (state, action: PayloadAction<number>) => {
      sessionStorage.setItem('ftsStatusForAgent', JSON.stringify(action.payload));
      state.ftsProfile = state.ftsProfile && { ...state.ftsProfile, ftsStatus: action.payload };
    },
    setFtsProfile: (state, action: PayloadAction<FtsOrganizationProfileDto>) => {
      sessionStorage.setItem('ftsProfile', JSON.stringify(action.payload));
      state.ftsProfile = action.payload;
    },
    setInn: (state, action: PayloadAction<string>) => {
      state.profile.inn = action.payload;
      sessionStorage.setItem('profile', JSON.stringify({ ...state.profile, inn: action.payload }));
    },
    setIsUserAgentFromInvitation: (state, action: PayloadAction<boolean>) => {
      sessionStorage.setItem('isUserAgentFromInvitation', JSON.stringify(action.payload));
      state.isUserAgentFromInvitation = action.payload;
    },
  },
});

export const { reducer: profileReducer, actions: profileActions } = profileSlice;
